import { Job } from 'graphql-common';
import _get from 'lodash/get';
import toast from '@lib/components/Toast/Toast';
import { getErrorMessage } from '@lib/utils/graphQLErrors';
import { TFunction } from 'i18next';

const fetchJobs = async ({
  jobIds,
  fetchJobStatus,
  onUpdateJobs,
  t,
}: {
  jobIds: string[];
  fetchJobStatus: any;
  onUpdateJobs: (jobs: Job[]) => void;
  t: TFunction<'translation', undefined>;
}) => {
  if (jobIds.length) {
    fetchJobStatus({
      variables: { jids: jobIds },
      onCompleted: (response: any) => {
        const updatedJobs = _get(response, 'data', []) as Job[];
        onUpdateJobs(updatedJobs);
      },
      onError: (error) => {
        console.error(error);
        toast({ content: getErrorMessage(error, t) });
      },
    });
  }
};

export default fetchJobs;
